import { Middleware } from "redux";
import { FETCH_MATCH_FEEDS_REQUESTED, FETCH_MATCH_ODDS_REQUESTED, CHANGE_CHANNEL, FETCH_STATS_RANKING_REQUESTED, FETCH_STATS_PLAYER_AGGREGATE_REQUESTED, FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, FETCH_STATS_TEAM_LAST_X_REQUESTED, FETCH_MATCH_DETAILS_EXTENDED_REQUESTED, FETCH_MATCH_EVENTS_REQUESTED, FETCH_MATCH_EVENTS_DELTA_REQUESTED, FETCH_MATCH_EVENTS_FAILED, FETCH_MATCH_EVENTS_SUCCEEDED } from "../actions/actionTypes";
import {
    getTournamentId,
    getLastEventIdByMatchId,
    getPlayerUidsByMatchId,
    getUniqueTournamentId
} from "../reducers/matches";
import {
    PHASE_PRE_MATCH,
    PHASE_POST_POINT,
    PHASE_BETSTOP,
    PHASE_POST_MATCH,
    PHASE_POST_GAME,
    PHASE_PRE_POINT
} from "../api/phases";
import { getPhaseIdByMatchId, getChannelIdByMatchId, getMatchIdByChannelId } from "../reducers/timings";
import { MiddlewareAPI } from "redux";
import { getActiveChannelId, getInitApplicationState } from "../reducers/gui";
import { IState } from "../store/state";
import { getPollInactiveChannels } from "../reducers/config";


const matchFeedsMiddleware: Middleware = (store:any) => next => action => {
    const result = next(action);
    switch (action.type) {
        case FETCH_MATCH_FEEDS_REQUESTED:
            const { matchId } = (action as any);
            const phaseId = getPhaseIdByMatchId(store.getState(),matchId);
            if( phaseId === PHASE_PRE_MATCH ) {
                // need new match data (team ids) before requesting the match feeds
                store.dispatch( { type: FETCH_MATCH_EVENTS_REQUESTED, matchId } )
            }
            else {
                fetchMatchFeeds(store,matchId);
            }
            break;
        case FETCH_MATCH_EVENTS_SUCCEEDED:
            if( getInitApplicationState(store.getState()) ) {
                fetchMatchFeeds(store,(action as any).data.doc[0].data.match._id);
            }
            break;
        case CHANGE_CHANNEL:
            const channelId = (action as any).id;
            fetchMatchFeeds(store,getMatchIdByChannelId(store.getState(),channelId));
            break;
    }
    return result;
}

const fetchMatchFeeds = (store:MiddlewareAPI<IState>,matchId:number) : void =>  {
    const state = store.getState();
    const phaseId = getPhaseIdByMatchId(state,matchId);
    const tournamentId = getTournamentId(state);
    const tournamentIdUnique = getUniqueTournamentId(state);
    const clubIds = getPlayerUidsByMatchId(state,matchId);
    const channelId = getChannelIdByMatchId(state,matchId);

    if( phaseId !== PHASE_PRE_MATCH && getLastEventIdByMatchId(state,matchId) ) {
        store.dispatch( { type: FETCH_MATCH_EVENTS_DELTA_REQUESTED, matchId } );
    }
    if( phaseId === PHASE_PRE_MATCH || phaseId == PHASE_POST_MATCH ) {
        store.dispatch( { type: FETCH_STATS_TEAM_LAST_X_REQUESTED, teamIdA:clubIds.home, teamIdB:clubIds.away, channelId } )
        store.dispatch( { type: FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, teamIdA:clubIds.home, teamIdB:clubIds.away, channelId } )
        store.dispatch( { type: FETCH_STATS_RANKING_REQUESTED, tournamentId } )
        store.dispatch( { type: FETCH_MATCH_DETAILS_EXTENDED_REQUESTED, matchId } );
    }
    if( channelId == getActiveChannelId(state) || getPollInactiveChannels(state) ) {
        store.dispatch( { type: FETCH_MATCH_DETAILS_EXTENDED_REQUESTED, matchId } );
        store.dispatch( { type: FETCH_STATS_PLAYER_AGGREGATE_REQUESTED, tournamentId: tournamentIdUnique, teamIdA:clubIds.home, teamIdB:clubIds.away, matchId, channelId } )
    }
    if( [PHASE_PRE_MATCH, PHASE_BETSTOP, PHASE_POST_POINT, PHASE_POST_MATCH].includes(phaseId) ) {
        store.dispatch( { type: FETCH_MATCH_ODDS_REQUESTED, matchId } );
    }
}

export default matchFeedsMiddleware;